import { useMemo } from "react";
import { AccessControlContext } from "../access-control-context";
import { AccessControlProviderProps } from "./types";

export const AccessControlProvider = ({
  roles,
  userInfo,
  businessOperations,
  children,
}: AccessControlProviderProps) => {
  const contextValue = useMemo(
    () => ({
      roles,
      userInfo,
      businessOperations,
    }),
    [userInfo]
  );

  return (
    <AccessControlContext.Provider value={contextValue}>
      {children}
    </AccessControlContext.Provider>
  );
};
